import { fade, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  sacola: { height: '35px' },
  badge: { bottom: '5px', right: 0 },
  badgeIcon: { bottom: '5px', right: 0 },
  carrinhoIcon: {
    height: '30px',
    width: '30px',
    fill: theme.palette.primary.contrastText,
    padding: 0,
    margin: 0
  },
  btnCarrinho: {
    fontSize: 16,
  },
  root: {
    position: 'fixed',
    width: '100%',
    minHeight: 64,
    bottom: 0,
    left: 0,
    zIndex: 100,
    backgroundColor: fade(theme.palette.background.paper, 0.8),
    backdropFilter: 'blur(5px)',
    display: 'flex',
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.15)',
  },
  container: {
    flex: 1,
    '& > div': {
      height: '100%',
    }
  },
  valorPedido: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1,
  },
  totalItens: {
    lineHeight: 1,
    fontSize: 16,
  }
}));